import { get } from 'lodash';
import ApiService from '@shared/services/api.service';

const state = {
  enums: {},
  planTypes: []
};

const mutations = {
  SET_ENUMS(state, data) {
    state.enums = data;
  },
  SET_PLAN_TYPE(state, data) {
    state.planTypes = data;
  }
};

const actions = {
  /**
   * Get configuration data
   * @param {*} param0
   */
  async GETENUMS({ commit }) {
    try {
      const res = await ApiService.get('/enums');
      commit('SET_ENUMS', res.data);
      const planTypes = get(res.data, 'url.plan_type');
      commit('SET_PLAN_TYPE', planTypes);
    } catch (err) {
      this.$showErrorMessage('An error occurred while trying to get the enums');
      throw err;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
